export default "__VITE_PUBLIC_ASSET__eb2e0ba2__"